var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tab__item-desktop-' + _vm.desktop + ' tab__item-mobile-' + _vm.mobile  + ' ' + _vm.activeClass],on:{"click":function($event){return _vm.clickTab()}}},[_c('ion-label',[_vm._v(_vm._s(_vm.tab.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }